import { observer } from 'mobx-react-lite'
import { useJobDetailsViewModel } from '@/features/jobs/details/JobDetailsView'
import { PageLayout } from '../../components/PageLayout'
import { ProInfoSectionContainer } from '@/features/jobs/details/components/ProInfoSection'
import { InlineResponsesSectionContainer } from '@/features/jobs/details/components/InlineResponsesSection'
import { TaxJobOverviewTab } from '@/features/jobs/details/tax-type/components/TaxJobDetailsOverview'
import { ConsultationJobOverviewTab } from '@/features/jobs/details/consultation-type/components/ConsultationJobDetailsOverview'
import { BookkeepingJobOverviewTab } from '@/features/jobs/details/bookkeeping-type/components/BookkeepingJobDetailsOverview'
import { SupportSectionContainer } from '@/features/jobs/details/components/SupportSection/SupportSectionContainer'
import { ConsultationJobDetailsViewModel } from '@/features/jobs/details/consultation-type/ConsultationJobDetailsViewModel'
import { BookkeepingJobDetailsViewModel } from '@/features/jobs/details/bookkeeping-type/BookkeepingJobDetailsViewModel'
import { TaxJobDetailsViewModel } from '@/features/jobs/details/tax-type/TaxJobDetailsViewModel'

/**
 * Job details overview tab.
 */
export default observer(function OverviewTab() {
  const vm = useJobDetailsViewModel()
  const displayContactSupport = Boolean(
    vm.job.workspace?.config.jobDetails.contactSupportEnabled,
  )

  if (vm.typeVm instanceof TaxJobDetailsViewModel) {
    return (
      <TaxJobOverviewTab
        vm={vm}
        taxVm={vm.typeVm}
        displayContactSupport={displayContactSupport}
      />
    )
  }

  if (vm.typeVm instanceof ConsultationJobDetailsViewModel) {
    return (
      <ConsultationJobOverviewTab
        vm={vm}
        consultationManagerVm={vm.typeVm.consultationManagerVm}
        displayContactSupport={displayContactSupport}
      />
    )
  }

  if (vm.typeVm instanceof BookkeepingJobDetailsViewModel) {
    return (
      <BookkeepingJobOverviewTab
        vm={vm}
        bookkeepingVm={vm.typeVm.bookkeepingVm}
        displayContactSupport={displayContactSupport}
      />
    )
  }

  return <DefaultJobOverviewTab />
})

/**
 * Default overview tab.
 */
const DefaultJobOverviewTab = observer(function DefaultJobOverviewTab() {
  const vm = useJobDetailsViewModel()

  const displayContactSupport = Boolean(
    vm.job.workspace?.config.jobDetails.contactSupportEnabled,
  )

  return (
    <PageLayout
      asideTop={<ProInfoSectionContainer vm={vm} />}
      asideBottom={displayContactSupport && <SupportSectionContainer />}
    >
      <InlineResponsesSectionContainer vm={vm.questionsDisplayVm} />
    </PageLayout>
  )
})
